import palette from '../../palette';

export default {
  root: {
    "&:focus": {
      color: palette.blueMain,
    }
  },
  yearSelected: {
    color: palette.blueMain,
  }
};
